import { render, staticRenderFns } from "./simcard.vue?vue&type=template&id=a7cb37d0&lang=html&"
import script from "./simcard.vue?vue&type=script&lang=js&"
export * from "./simcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports